import { apiFetch } from './prospects';

export async function confirmPayment(token) {
  return apiFetch(`/payments/confirm/${encodeURIComponent(token)}`);
}

